import React from 'react';
import styles from "./item-list-slider.scss";
import { getHighlightString } from "../../utills";
import withRipple from "jd-library/withRipple";

const ItemResult = props => {

    const { item, searchText, autoSuggestion } = props;

    const highlighttext = item => {
        return getHighlightString({
            searchKey: searchText,
            searchResult: item.catName,
            className: styles["search-highlight"]
        });
    };

    return (
        <>
            <div
                key={item.id}
                className={styles["default-auto-suggestion"] + ' ' + props.rippleClass}
                onClick={e => setTimeout(() => { autoSuggestion.onItemClick(item) }, 300)}
                {...props.rippleHandler}
            >
                <div className={styles["left-side"]}>
                    <i
                        className={`${styles["btn-style"]} ${item.icon ||
                            autoSuggestion.icon}`}
                    ></i>
                </div>
                <div
                    className={styles["right-side"]}
                >
                    <span
                        className={styles["text-style"]}
                        dangerouslySetInnerHTML={{ __html: highlighttext(item) }}
                    ></span>
                </div>
                {props.renderRipple()}
            </div>
            <div className={styles["list-divider"]}></div>
        </>
    );
}

export default withRipple(ItemResult);